import { Route, Routes } from '@angular/router';

import { PatientGroupsComponent } from '@features/patient-groups/patient-groups.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { CanDeactivateGuard } from '@shared/guards/can-deactivate.guard';

import { CustomDriversComponent } from './drivers/custom-drivers/custom-drivers.component';
import { CustomDriversGuard } from './drivers/custom-drivers/guards/custom-drivers.guard';
import { DriversComponent } from './drivers/drivers.component';
import { ForecastSiteDriversComponent } from './drivers/forecast-sites-drivers/forecast-site-drivers.component';
import { ForecastSiteCurvesComponent } from './drivers/forecast-sites-drivers/tabs/forecast-site-curves/forecast-site-curves.component';
import { ForecastSiteGroupsComponent } from './drivers/forecast-sites-drivers/tabs/forecast-site-groups/forecast-site-groups.component';
import { PatientAndSiteDriversGuard } from './drivers/guards/patient-and-site-drivers.guard';
import { PatientDriversComponent } from './drivers/patient-drivers/patient-drivers.component';
import { PatientCurvesComponent } from './drivers/patient-drivers/patients/patient-curves.component';
import { ForecastComponent } from './forecast/forecast.component';
import { ForecastAccrualsPageComponent } from './forecast-accruals-page.component';
import { ForecastGuard } from './guards/forecast.guard';
import { TimelineComponent } from './timeline-group/timeline/timeline.component';

const enabledRoutes: Routes = [
  {
    canActivate: [ForecastGuard],
    canDeactivate: [CanDeactivateGuard],
    component: ForecastComponent,
    path: ROUTING_PATH.FORECAST_ROUTING.FORECAST_METHODOLOGY,
  },
  {
    canDeactivate: [CanDeactivateGuard],
    component: TimelineComponent,
    path: ROUTING_PATH.FORECAST_ROUTING.TIMELINE,
  },
  {
    children: [
      {
        canActivate: [CustomDriversGuard],
        canDeactivate: [CanDeactivateGuard],
        component: CustomDriversComponent,
        path: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.CUSTOM_DRIVERS,
      },
      {
        canActivate: [PatientAndSiteDriversGuard],
        canActivateChild: [PatientAndSiteDriversGuard],
        children: [
          {
            canDeactivate: [CanDeactivateGuard],
            component: PatientCurvesComponent,
            path: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.PATIENT_DRIVER.CURVES,
          },
          {
            canDeactivate: [CanDeactivateGuard],
            component: PatientGroupsComponent,
            path: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.PATIENT_DRIVER.GROUPS,
          },
          {
            path: '**',
            redirectTo: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.PATIENT_DRIVER.CURVES,
          },
        ],
        component: PatientDriversComponent,
        path: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.PATIENT_DRIVER.INDEX,
      },
      {
        canActivate: [PatientAndSiteDriversGuard],
        canActivateChild: [PatientAndSiteDriversGuard],
        children: [
          {
            canDeactivate: [CanDeactivateGuard],
            component: ForecastSiteCurvesComponent,
            path: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.SITE_DRIVER.CURVES,
          },
          {
            canDeactivate: [CanDeactivateGuard],
            component: ForecastSiteGroupsComponent,
            path: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.SITE_DRIVER.GROUPS,
          },
          {
            path: '**',
            redirectTo: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.SITE_DRIVER.CURVES,
          },
        ],
        component: ForecastSiteDriversComponent,
        path: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.SITE_DRIVER.INDEX,
      },
      {
        path: '**',
        redirectTo: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.CUSTOM_DRIVERS,
      },
    ],
    component: DriversComponent,
    path: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.INDEX,
  },
];

export const buildForecastRoutes = (): Route => {
  return {
    children: [
      ...enabledRoutes,
      { path: '**', redirectTo: ROUTING_PATH.FORECAST_ROUTING.FORECAST_METHODOLOGY },
    ],
    component: ForecastAccrualsPageComponent,
    path: ROUTING_PATH.FORECAST_ROUTING.INDEX,
  };
};
